import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/providers/data.service';
import { StudentClassService } from '../../providers/student-class/student-class.service';

@Component({
  selector: 'app-class-student-modal',
  templateUrl: './class-student-modal.component.html',
  styleUrls: ['./class-student-modal.component.scss'],
  providers: [DataService]
})
export class ClassStudentModalComponent implements OnInit {
  classForm: FormGroup;
  levels;
  local_data: any;
  id: number;

  public dataStudentList$: Observable<[]>;

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ClassStudentModalComponent>,
    public dataService: DataService,
    private Service: StudentClassService,
    @Optional() @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {
    if (!this.data.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.classForm = new FormGroup({
      Class_Sysref: new FormControl(this.data.class.sysRef),
      Students: this.fb.array([])
    });

  }

  editForm() {
    this.classForm = new FormGroup({
      Class_Sysref: new FormControl(this.data.class.sysRef),
      Students: this.fb.array([])
    });

    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.dataStudentList$ = this.dataService.StudentList
    this.dataService.getStudentData().subscribe();
    //console.log(this.dataStudentList$);
    console.log(this.data);

    this.reAddStudents();
  }

  addStudents() {
    //console.log(this.classForm.value)
    this.Service.addStudentClass(this.classForm.value)
      .subscribe(x=> console.log(x));
  }

  students(): FormArray {
    return this.classForm.get('Students') as FormArray
  }

  newStudent(): FormGroup {
    return this.fb.group({
      Sysref: new FormControl()
    })
  }

  addStudent() {
    this.students().push(this.newStudent());
  }

  reAddStudents() {
    let students = this.data.class.students;

    for (let i = 0; i < students.length; i++) {
      let tmp = this.fb.group({
        Sysref: new FormControl(students[i].sysref)
      })

      this.students().push(tmp);
    }
  }
}
